import { Button, dialog } from "nq-component";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import InputFactory from "../../../../components/InputFactory";
// import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";

const RESIDENTIAL_TO_PERMANENT = {
  residentialHouseNo: "permanentHouseNo",
  residentialZipCode: "permanentZipCode",
  residentialStreet: "permanentStreet",
  residentialSubdivision: "permanentSubdivision",
  recidentialRegion: "permanentRegion",
  recidentialProvince: "permanentProvince",
  recidentialCity: "permanentCity",
  recidentialBrangay: "permanentBrangay",
};

class EmployeeFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
  originalObject = null;

  mirrorResidentialToPermanent(object) {
    if (!object?.bool) return { ...object };

    const mirrored = { ...object };
    Object.entries(RESIDENTIAL_TO_PERMANENT).forEach(
      ([residentialField, permanentField]) => {
        if (object[residentialField] !== undefined) {
          mirrored[permanentField] = object[residentialField];
        }
      },
    );
    return mirrored;
  }

  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    if (field === "bool" && value) {
      this.object = this.mirrorResidentialToPermanent(this.object);
      Object.values(RESIDENTIAL_TO_PERMANENT).forEach((permanentField) => {
        this.change[permanentField] = this.object[permanentField];
      });
    } else if (this.object.bool && RESIDENTIAL_TO_PERMANENT[field]) {
      const permanentField = RESIDENTIAL_TO_PERMANENT[field];
      this.object[permanentField] = value;
      this.change[permanentField] = value;
    }

    this.view.setObject(this.object);
  }

  // Override getObject in EmployeeFormPresenter to capture original
  async getObject() {
    await super.getObject();
    if (this.object?.bool) {
      this.object = this.mirrorResidentialToPermanent(this.object);
      this.view.setObject(this.object);
    }
    if (this.object?.id) {
      this.originalObject = structuredClone(this.object);
    }
  }

  calculateAge(birthDate) {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear() || 0;
    const monthDifference = today.getMonth() - birthDateObj.getMonth();

    // If the birth date hasn't occurred yet this year, subtract one year from the age
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }

    return age;
  }

  createInputValue(object) {
    const age = this.calculateAge(object.birthDate);
    return {
      ...this.mirrorResidentialToPermanent(object),
      age,
    };
  }

  // Additional TAB Function

  handleToggleState = (key) => {
    this.view.setState((prevState) => ({ [key]: !prevState[key] }));
  };

  toggleItemChildList(question, fieldState, field, object, options = {}) {
    const { disabled = false } = options;
    return (
      <>
        <p className="col-lg-6 d-flex align-items-center mt-2">{question}</p>
        <button
          type="button"
          className="btn col-lg-3 w-auto p-0 me-5 border-0 bg-transparent shadow-none"
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            this.handleToggleState(field);
          }}
        >
          <i
            className={`text-center ${
              fieldState ? "bi bi-toggle-on" : "bi bi-toggle-off"
            }`}
            style={{ zoom: 1.5, padding: 0 }}
          ></i>
        </button>
        <div
          className={`col-lg-3 ${
            fieldState ? "" : "d-none"
          } d-flex align-items-center`}
        >
          <InputFactory
            uppercase
            placeholder="Please give details"
            type="String"
            object={object}
            field={field}
            disabled={disabled}
            onChange={this.onChange.bind(this)}
          />
        </div>
      </>
    );
  }

  toggleItemParentList(question, fieldState, field, object, options = {}) {
    const { disabled = false } = options;
    return (
      <li>
        <div className="row">
          <p className="col-lg-6 d-flex align-items-center mt-2">{question}</p>
          <button
            type="button"
            className="btn col-lg-3 w-auto p-0 me-5 border-0 bg-transparent shadow-none"
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              this.handleToggleState(field);
            }}
          >
            <i
              className={`text-center ${
                fieldState ? "bi bi-toggle-on" : "bi bi-toggle-off"
              }`}
              style={{ zoom: 1.5, padding: 0 }}
            ></i>
          </button>
          <div
            className={`col-lg-3 ${
              fieldState ? "" : "d-none"
            } d-flex align-items-center`}
          >
            <InputFactory
              uppercase
              placeholder="Please give details"
              type="String"
              object={object}
              field={field}
              disabled={disabled}
              onChange={this.onChange.bind(this)}
            />
          </div>
        </div>
      </li>
    );
  }

  isUpdate() {
    return Boolean(this.view.getObjectId?.() || this.view.props?.object_ID);
  }

  showDialogSubmit(object) {
    if (this.view.state.isLoading) return;

    const isUpdate = this.isUpdate();

    dialog.fire({
      html: (
        <div className="p-2">
          <h4>{isUpdate ? "Update Employee" : "New Employee"}</h4>
          <hr />
          <p style={{ margin: "2rem 0" }}>
            {isUpdate
              ? "Click confirm to update this employee."
              : "Click confirm to create this employee."}
          </p>
          <hr />
          <div className="w-100 d-flex justify-content-end gap-4 mb-3">
            <Button
              className="btn btn-light fs-sm"
              disabled={this.view.state.isLoading}
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              progress={this.view.state.isLoading}
              disabled={this.view.state.isLoading}
              onClick={() => {
                if (this.view.state.isLoading) return;
                this.view.setState({ isLoading: true });
                sessionStorage.clear();
                this.handleSubmitData(object);
              }}
              className="btn btn-primary"
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  getChangedValues = (oldData, newData) => {
    const getRefId = (value) =>
      value && typeof value === "object" && "id" in value ? value.id : value;

    const isEqual = (a, b) => {
      if (a === b) return true;
      const aId = getRefId(a);
      const bId = getRefId(b);
      if (a !== aId || b !== bId) {
        return aId === bId;
      }
      if (
        a &&
        b &&
        typeof a === "object" &&
        typeof b === "object"
      ) {
        return JSON.stringify(a) === JSON.stringify(b);
      }
      return false;
    };

    const changes = Object.keys(newData).reduce((acc, key) => {
      if (key === "id" || key === "lengthOfService") return acc;
      if (!isEqual(oldData[key], newData[key])) {
        acc[key] = newData[key];
      }
      return acc;
    }, {});

    if (changes.hired && newData.lengthOfService != null) {
      changes.lengthOfService = newData.lengthOfService;
    }

    return { ...changes, id: newData.id };
  };

  handleSubmitData = async (object) => {
    const isUpdate = this.isUpdate();
    dialog.close();
    const submitObject = this.getChangedValues(
      this.originalObject || {},
      object,
    );
    const {
      salaryPointer,
      employmentType,
      selectedSchedule,
      position,
      // twentyFourSeven,
      ...newobject
    } = submitObject;

    const biometricID = await findObjectUseCase().execute("employees", {
      keys: ["id", "biometricId"],
      limit: 1,
      sort: { biometricId: -1 },
    });

    const otherInfoObject = {
      ...newobject,
      ...(employmentType ? { employmentType: { id: employmentType.id } } : {}),
      ...(selectedSchedule
        ? { selectedSchedule: { id: selectedSchedule.id } }
        : selectedSchedule === null
          ? { selectedSchedule }
          : {}),
      ...(salaryPointer ? { salaryPointer: { id: salaryPointer.id } } : {}),
      ...(position ? { position: { id: position.id } } : {}),
    };

    // Detect if these fields changed (only for updates, not new employees)
    const employmentTypeChanged =
      otherInfoObject && otherInfoObject.employmentType?.id;
    const twentyFourSevenChanged =
      otherInfoObject && otherInfoObject.twentyFourSeven;
    const selectedScheduleChanged =
      otherInfoObject && otherInfoObject?.selectedSchedule?.id;
    // Use employmentTypeChanged / twentyFourSevenChanged / selectedScheduleChanged for your logic here
    if (employmentTypeChanged) {
      otherInfoObject.employment_type_assignment = {
        employeeId: otherInfoObject?.id,
        name: employmentType?.name,
      };
    }
    if (twentyFourSevenChanged) {
      otherInfoObject.twenty_fourSeven_assignment = {
        employeeId: otherInfoObject.id,
        name: otherInfoObject.twentyFourSeven,
      };
    }
    if (selectedScheduleChanged && selectedSchedule) {
      const { id, ...restData } = selectedSchedule;
      otherInfoObject.selected_schedule_assignment = {
        employeeId: otherInfoObject.id,
        ...restData,
      };
    }

    try {
      if (!this.object?.biometricId && biometricID.length > 0) {
        otherInfoObject.biometricId = biometricID[0].biometricId + 1;
      }
      if (
        otherInfoObject?.supervisor &&
        Object.keys(otherInfoObject.supervisor).length === 0
      ) {
        otherInfoObject.supervisor = null;
      }
      console.log("otherInfoObject: ", otherInfoObject);
      await upsertUseCase().execute("employees", otherInfoObject);
      this.insertServiceRecord(otherInfoObject, position, employmentType);
      this.view.navigateBack();
      this.view.showSuccess(
        isUpdate
          ? "Employee updated successfully"
          : "Employee created successfully",
      );
    } catch (e) {
      console.error(e.message || e);
      this.view.showError(e.message || e);
    } finally {
      this.view.setState({ isLoading: false });
    }
  };

  async insertServiceRecord(updateEmployee, position, employmentType) {
    // console.log("POSITION: ", position);
    // console.log("EMPLOYMENT TYPE: ", employmentType);
    const effectivity = updateEmployee?.hired
      ? new Date(updateEmployee.hired)
      : new Date();
    const serviceRec = await findObjectUseCase().execute("service_record", {
      where: { empID: updateEmployee?.id },
      keys: ["id"],
    });

    if (serviceRec.length > 0) {
      return;
    }

    const designation = position?.position_title
      ? position?.position_title
      : position?.name;

    const dateFrom = serviceRec[0]?.from
      ? new Date(serviceRec[0]?.from)
      : new Date();
    dateFrom.setDate(dateFrom.getDate() - 1);

    let salary = "";
    if (updateEmployee?.salaryGrade) {
      salary = updateEmployee?.salaryGrade.replace(
        /₱\s?([\d,]+\.\d{2})/,
        (_, num) => `₱ ${(parseFloat(num.replace(/,/g, "")) * 12).toFixed(2)}`,
      );
    }

    const serviceLog = {
      email: updateEmployee?.email,
      empID: updateEmployee?.id,
      from: effectivity,
      employee: { id: updateEmployee.id },
      designation: designation || "",
      status: employmentType?.name || "",
      salary: salary,
      station: "BUREAU OF IMMIGRATION",
      branch: "NATIONAL",
      cause: "ORIGINAL",
    };
    try {
      await upsertUseCase().execute("service_record", serviceLog);
    } catch (e) {
      console.error(e.message || e);
      this.view.showError(e.message || e);
    }
  }
}

export default EmployeeFormPresenter;
